var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { createRef } from 'react';
import { Dropdown, DropdownPositions } from './Dropdown';
import { canUseDOM } from 'exenv';
import { registerClass } from '@food/css-manager';
var tooltipClass = registerClass(function (t) { return "\n\tbackground: transparent;\n\t\n\t> div {\n\t\tbackground-color: " + t.colors.grey.dark + ";\n\t\tcolor: " + t.colors.white + ";\n\t\tpadding-top: " + (t.ratios.xs / 2) * t.font.baseSize + "px;\n\t\tpadding-bottom: " + (t.ratios.xs / 2) * t.font.baseSize + "px;\n\t\tpadding-left: " + t.ratios.s * t.font.baseSize + "px;\n\t\tpadding-right: " + t.ratios.s * t.font.baseSize + "px;\n\t\tborder-radius: .3em;\n\t\tposition: relative;\n\t\tmargin-bottom: 5px;\n\t\t\n\t\t&::after {\n\t\t\tcontent: \" \";\n\t\t\tposition: absolute;\n\t\t\ttop: 100%; /* At the bottom of the tooltip */\n\t\t\tleft: 20%;\n\t\t\tmargin-left: -5px;\n\t\t\tborder-width: 5px;\n\t\t\tborder-style: solid;\n\t\t\tborder-color: " + t.colors.grey.dark + " transparent transparent transparent;\n\t\t}\n\t}\n"; }, true);
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.originalRef = createRef();
        _this.tooltipRef = createRef();
        _this.state = {
            open: false,
        };
        _this.open = function () {
            _this.setState({ open: true });
            clearTimeout(_this.closeTimeout);
        };
        _this.close = function () { return _this.setState({ open: false }); };
        _this.timedClose = function () { return (_this.closeTimeout = setTimeout(_this.close, 100)); };
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        if (canUseDOM) {
            var originalElem = this.originalRef.current;
            var tooltipElem = this.tooltipRef.current;
            if (!originalElem || !tooltipElem) {
                return;
            }
            originalElem.addEventListener('mouseenter', this.open);
            tooltipElem.addEventListener('mouseenter', this.open);
            originalElem.addEventListener('mouseleave', this.timedClose);
            tooltipElem.addEventListener('mouseleave', this.timedClose);
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        if (canUseDOM) {
            var originalElem = this.originalRef.current;
            var tooltipElem = this.tooltipRef.current;
            if (!originalElem || !tooltipElem) {
                return;
            }
            originalElem.removeEventListener('mouseenter', this.open);
            tooltipElem.removeEventListener('mouseenter', this.open);
            originalElem.removeEventListener('mouseleave', this.timedClose);
            tooltipElem.removeEventListener('mouseleave', this.timedClose);
        }
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, C = _a.component, children = _a.children;
        var open = this.state.open;
        return (React.createElement(React.Fragment, null,
            React.createElement(Dropdown, { element: this.originalRef, open: open, preferredPosition: DropdownPositions.Above, className: tooltipClass },
                React.createElement("div", { ref: this.tooltipRef },
                    React.createElement(C, null))),
            React.createElement("section", { ref: this.originalRef }, children)));
    };
    return Tooltip;
}(React.PureComponent));
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map